import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';

// Gradient-header section wrapper, mirroring the legacy JobEnteredSummary card.
const SummaryCard = ({ title, subtitle, linkTo, linkLabel, children }) => (
  <div
    className="tw-bg-white tw-mb-3 tw-h-full"
    style={{ boxShadow: '0 0.125rem 0.5rem rgba(0,0,0,0.075)', borderRadius: 12, overflow: 'hidden' }}
  >
    <div
      className="tw-flex tw-items-center tw-justify-between"
      style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)', padding: '1rem 1.25rem' }}
    >
      <div>
        <h5 className="tw-mb-0 tw-font-bold tw-text-slate-700">{title}</h5>
        {subtitle && <small className="tw-text-slate-500">{subtitle}</small>}
      </div>
      {linkTo && (
        <Link to={linkTo} className="tw-text-sm tw-font-semibold tw-no-underline tw-flex tw-items-center">
          {linkLabel || 'Open full dashboard'} <FiArrowRight size={13} className="tw-ml-1" />
        </Link>
      )}
    </div>
    <div className="tw-p-3">
      <div className="tw-grid tw-grid-cols-12 tw-gap-3">{children}</div>
    </div>
  </div>
);

SummaryCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  linkTo: PropTypes.string,
  linkLabel: PropTypes.string,
  children: PropTypes.node
};

export default SummaryCard;
